import { FC } from 'react';
import { GoalValue } from './WeeklyGoalWrapper';
import { useSkillIcon } from '../../custom-hooks/useSkillIcon';

interface Props {
  item: GoalValue;
}

const WeeklyGoalCoreSkillList: FC<Props> = ({ item }) => {
  const { IconComponent } = useSkillIcon({ targetSkillType: item.skillType, className: 'icon-sm' });

  return (
    <>
      <IconComponent />
      <span className="tw-font-atkinson tw-text-base tw-font-bold"> {item.code}</span>
      <span className="tw-font-atkinson tw-text-base"> {item.name}</span>
    </>
  );
};

export default WeeklyGoalCoreSkillList;
